import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { ModalDetailEventComponent } from '../modal-detail-event/modal-detail-event.component';
interface DialogData  {
  day: Date;
}
@Component({
  selector: 'app-modal-create-event',
  templateUrl: './modal-create-event.component.html',
  styleUrls: ['./modal-create-event.component.scss']
})
export class ModalCreateEventComponent implements OnInit {
  loading = false;
  monthNotifications = 0;
  initialDate: Date | null = null;
  constructor(public dialogRef: MatDialogRef<ModalDetailEventComponent>,
    public dataService: DataService,
    public matDialog: MatDialog,
    public authService: AuthService,
    public fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) { }

  async ngOnInit() {
    this.monthNotifications = await this.dataService.getNotificationsCountForCurrentMonth(this.authService.userData.brandId);
    
    console.log('');
    console.log('');
    console.log('this.data.date ', this.data.day);
    console.log('');
    console.log('');
    
    this.initialDate = this.data.day;
  }

  close() {
    this.matDialog.closeAll();
  }

  closeDialog() {
    this.dataService.$eventSaved.emit(true);
  }
}
